module.exports = __webpack_public_path__ + "img/about-company1.ac65578d.png";